/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 09.09.2016.
 */

import React, {Component, PropTypes} from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {VelocityComponent} from 'velocity-react';
import ClassNames from 'classnames';

import _get from 'lodash/get';
import _debounce from 'lodash/debounce';
import _throttle from 'lodash/throttle';

import {WindowDimensions, GetLocalStorageValue, SetLocalStorageValue} from '../../utils';
import YoutubePlayer from './YoutubePlayer';
import CLPP from './CLPP';
import RMP from './RadiantMediaPlayer';

import {SetPlayer} from '../../actions/common/actions-common';

export const STATES = {
  'IDLE': 'idle',
  'PLAYING': 'playing'
};

export const ACTIONS = {
  'START': 'start',
  'PAUSE': 'pause',
  'RESUME': 'resume',
  'STOP': 'stop',
  'OPEN': 'open',
  'CLOSE': 'close',
  'BLOCK': 'block',
  'GEO_BLOCK': 'geo-block',
  'MURTISCREEN_BLOCK': 'multiscreen-block',
  'SET_METADATA': 'set-metadata',
  'SHOW_METADATA': 'show-metadata',
  'DETACH': 'detach-player-container-and-make-movable',
  'CLOSE_DETACH': 'close-detach-player',
  'RESIZE_DETACHED': 'resize-detached-player'
};

class Player extends Component {
  _handleLimitReached = () => {
    this.setState({
      player: {
        stream_url: '',
        container: null,
        action: ACTIONS.MURTISCREEN_BLOCK,
        type: 'multiscreen-block',
      }
    });
  };

  constructor(props) {
    super(props);
    this.size = {
      width: 460,
      height: 270
    };

    this.scale = GetLocalStorageValue('player-scale', 1);
    this.dragableElem = null;
    this.prevCursorPosition = {
      x: 0,
      y: 0
    };

    this.state = {
      state: STATES.IDLE,
      isVisible: false,
      isDetached: false,
      showAdditionalControls: false,
      player: null,
      position: {
        x: 0,
        y: 0
      },
      container: null,
      containerPosition: {}
    };

    this._handleWindowResize = _debounce(this._setPosition.bind(this, undefined), 100);
    this._bindedHandleMouseDown = this._handleMouseDown.bind(this);
    this._bindedHandleMouseMove = _throttle(this._handleMouseMove.bind(this), 10);
    this._bindedHandleMouseUp = this._handleMouseUp.bind(this);
    this._bindedHandleTouchStart = this._handleTouchStart.bind(this);
    this._bindedHandleTouchMove = this._handleTouchMove.bind(this);
    //this._bindedHandleTouchMove = _throttle(this._handleTouchMove.bind(this), 10);
    this._bindedHandleTouchEnd = this._handleTouchEnd.bind(this);
  }

  componentWillMount() {

    window.addEventListener('resize', this._handleWindowResize);

    this.setState({
      player: this.props.player
    })
  }

  componentWillReceiveProps(newProps) {
    if (newProps.player.action !== this.props.player.action) {

      switch (newProps.player.action) {
        case ACTIONS.OPEN:
          this.setState({
            isVisible: true,
            container: newProps.player.container
          });

          this._setPosition(newProps.player.container);

          this.timeoutFirst = setTimeout(() => {

            this._setPosition(newProps.player.container);
          }, 1000);

          this.timeoutTwo = setTimeout(() => {

            this._setPosition(newProps.player.container);
          }, 2000);
          break;

        case ACTIONS.CLOSE:
          if (!this.state.isDetached) {
            this.setState({
              isVisible: false,
              container: null
            });

            this._setPosition(newProps.player.container);
          }

          break;

        case ACTIONS.GEO_BLOCK:
        case ACTIONS.MURTISCREEN_BLOCK:
        case ACTIONS.BLOCK:
          this.setState({
            isVisible: true,
            container: newProps.player.container,
          });

          this._setPosition(newProps.player.container);

          break;

        case ACTIONS.DETACH:
          this._onDetach();

          break;

        case ACTIONS.CLOSE_DETACH:
          this._onCloseDetached();

          break;
      }
    }

    if (!this.state.isDetached || newProps.player.action !== ACTIONS.CLOSE) {

      this.setState({
        player: newProps.player
      })
    }
  }

  componentWillUnmount() {
    this._onDetach();

    if (this.timeoutFirst) clearTimeout(this.timeoutFirst);
    if (this.timeoutTwo) clearTimeout(this.timeoutTwo);

    window.removeEventListener('resize', this._handleWindowResize);
    this.dragableElem.removeEventListener('mousedown', this._bindedHandleMouseDown);
    this.dragableElem.removeEventListener('touchstart', this._bindedHandleTouchStart);
  }

  _onMouseEnterHandler() {

    this.setState({
      showAdditionalControls: true,
    })
  }

  _onMouseLeaveHandler() {

    this.setState({
      showAdditionalControls: false,
    })
  }

  _handleMouseDown(e) {
    e.preventDefault();

    let clientX = e.clientX;
    let clientY = e.clientY;

    this.prevCursorPosition = {
      x: clientX,
      y: clientY
    };

    window.addEventListener('mousemove', this._bindedHandleMouseMove, true);
    window.addEventListener('mouseup', this._bindedHandleMouseUp);
  }

  _handleMouseMove(e) {
    if (e.nativeEvent) {
      e.nativeEvent.preventDefault();
      e.nativeEvent.stopPropagation();
    }

    e.preventDefault();
    e.stopPropagation();

    let clientX = e.clientX;
    let clientY = e.clientY;

    let deltaX = clientX - this.prevCursorPosition.x;
    let deltaY = clientY - this.prevCursorPosition.y;

    this.prevCursorPosition = {
      x: clientX,
      y: clientY
    };

    let {width, height} = WindowDimensions();

    let newX = this.state.position.x + deltaX;
    let newY = this.state.position.y + deltaY;
    this.setState({
      position: {
        x: newX < 10 ? 10 : newX > +width - (this.size.width * (+this.scale) + 35) ? +width - (this.size.width * (+this.scale) + 35) : newX,
        y: newY < 10 ? 10 : newY > +height - (this.size.height * (+this.scale) + 60) ? +height - (this.size.height * (+this.scale) + 60) : newY
      }
    });
  }

  _handleMouseUp(e) {
    e.preventDefault();

    window.removeEventListener('mousemove', this._bindedHandleMouseMove, true);
    window.removeEventListener('mouseup', this._bindedHandleMouseUp);
  }

  _handleTouchStart(e) {
    let {touches} = e;
    if (touches && touches.length === 1) {
      let {clientX, clientY} = touches[0];

      this.prevCursorPosition = {
        x: clientX,
        y: clientY
      };

      document.body.addEventListener('touchmove', this._bindedHandleTouchMove, true);
      window.addEventListener('touchend', this._bindedHandleTouchEnd);
    }

    return false;
  }

  _handleTouchMove(e) {
    //e.stopPropagation && e.stopPropagation();
    //e.preventDefault && e.preventDefault();

    let {touches} = e;
    if (touches && touches.length === 1) {
      let {clientX, clientY} = touches[0];

      let deltaX = clientX - this.prevCursorPosition.x;
      let deltaY = clientY - this.prevCursorPosition.y;

      this.prevCursorPosition = {
        x: clientX,
        y: clientY
      };

      let {width, height} = WindowDimensions();

      let newX = this.state.position.x + deltaX;
      let newY = this.state.position.y + deltaY;
      this.setState({
        position: {
          x: newX < 10 ? 10 : newX > +width - (this.size.width * (+this.scale) + 35) ? +width - (this.size.width * (+this.scale) + 35) : newX,
          y: newY < 10 ? 10 : newY > +height - (this.size.height * (+this.scale) + 60) ? +height - (this.size.height * (+this.scale) + 60) : newY
        }
      });
    }
  }

  _handleTouchEnd(e) {

    console.log('touch end');
    document.body.removeEventListener('touchmove', this._bindedHandleTouchMove, true);
    window.removeEventListener('touchend', this._bindedHandleTouchEnd);
  }

  _onClickDetach() {

    this.props.SetPlayer({
      ...this.state.player,
      action: ACTIONS.DETACH
    });
  }

  _onClickClose() {

    this.props.SetPlayer({
      action: ACTIONS.CLOSE_DETACH
    });
  }

  _onDetach() {
    let {width, height} = WindowDimensions();

    this.setState({
      isDetached: true,
      position: {
        x: +width - (this.size.width * (+this.scale) + 35),
        y: +height - (this.size.height * (+this.scale) + 60)
      }
    });

    this.props.SetPlayer({
      ...this.state.player,
      width: this.size.width * (+this.scale),
      height: this.size.height * (+this.scale),
      action: ACTIONS.RESIZE_DETACHED
    });

    this.dragableElem = ReactDOM.findDOMNode(this).querySelector('.top-controls');

    this.dragableElem.addEventListener('mousedown', this._bindedHandleMouseDown);
    this.dragableElem.addEventListener('touchstart', this._bindedHandleTouchStart);
  }

  _onCloseDetached() {
    this.dragableElem.removeEventListener('mousedown', this._bindedHandleMouseDown);
    this.dragableElem.removeEventListener('touchstart', this._bindedHandleTouchStart);

    this.setState({
      isDetached: false,
      player: {
        stream_url: '',
        container: null,
        action: ACTIONS.CLOSE
      }
    });

    this.props.SetPlayer({
      stream_url: '',
      container: null,
      action: ACTIONS.CLOSE,
      monitoring: null
    });

    this._setPosition(null);
  }

  _onResizeDetached() {
    if (!this.state.isDetached) {

      return;
    }

    this.scale = (this.scale == 1) ? 1.5 : (this.scale == 1.5) ? 2 : 1;
    SetLocalStorageValue('player-scale', this.scale);

    this._setPosition();

    this.props.SetPlayer({
      ...this.state.player,
      width: this.size.width * (+this.scale),
      height: this.size.height * (+this.scale),
      action: ACTIONS.RESIZE_DETACHED
    });
  }

  _setPosition(container = this.state.container) {
    if (container) {
      if (this.state.isDetached) {

        let {width, height} = WindowDimensions();

        this.setState({
          position: {
            x: this.state.position.x < 10 ? 10 : this.state.position.x > +width - (this.size.width * (+this.scale) + 35) ? +width - (this.size.width * (+this.scale) + 35) : this.state.position.x,
            y: this.state.position.y < 10 ? 10 : this.state.position.y > +height - (this.size.height * (+this.scale) + 60) ? +height - (this.size.height * (+this.scale) + 60) : this.state.position.y
          }
        });

      } else {

        let top = (window.scrollY || window.pageYOffset);
        let left = (window.scrollX || window.pageXOffset);

        let clientRects = container.getClientRects();

        let position = {x: _get(clientRects, '[0].left') + left, y: _get(clientRects, '[0].top') + top};

        this.setState({
          position: position,
          containerPosition: clientRects
        });
      }
    } else {

      this.setState({
        position: {x: '-2000px'},
        containerPosition: {}
      });
    }
  }

  _renderPlayer() {

    switch (this.state.player.type) {
      case 'youtube':
        return (
          <YoutubePlayer player={this.state.player}/>
        );

      case 'clpp':
        return (
          <CLPP player={this.state.player} onLimitReached={this._handleLimitReached}/>
        );

      case 'rmp':
        return (
            <RMP player={this.state.player} onLimitReached={this._handleLimitReached}/>
        );

      case 'multiscreen-block':
        return (
          <div className="crow no-gutter">
            <div className="text-center">
              <img src={`/images/${Config.white_skin ? 'white' : 'black'}/screen-limit.svg`} style={{
                width: '86px',
              }}/>
              <h3 className="mt+">Screen Limit</h3>
              <h6>Too many people are using your account right now. Upgrade your plan or stop playing on one of the
                other devices.</h6>
            </div>
          </div>
        );
      case 'geo-blocker':
        return (
          <div className="crow no-gutter">
            <div className="text-center">
              <img src={`/images/${Config.white_skin ? 'white' : 'black'}/geo-lock.svg`} style={{
                width: '86px',
              }}/>
              <h3 className="mt+">Content is not available in your geographical location</h3>
            </div>
          </div>
        );
      case 'blocker':
        return (
          <div className="crow no-gutter">
            <div className="text-center">
              <img src={`/images/${Config.white_skin ? 'white' : 'black'}/warning.svg`} style={{
                width: '86px',
              }}/>
              <h3 className="mt+">Subscription expired</h3>
            </div>
          </div>
        );

      default:

        return (<div>
          <h2> Player </h2>
        </div>);
    }
  }

  render() {

    const containerClass = ClassNames({
      'show': this.state.isVisible,
      'detached radius bg-black': this.state.isDetached,
      'player-container': true
    });

    const controlsClass = ClassNames({
      'draggable': this.state.isDetached,
      'top-controls': true
    });

    const position = {
      top: this.state.position.y,
      left: this.state.position.x,
      width: this.size.width * (this.state.isDetached ? +this.scale : 1) + 'px',
      height: this.size.height * (this.state.isDetached ? +this.scale : 1) + 'px',
    };

    return (
      <div id="player" className={containerClass} style={position}
           onMouseEnter={this._onMouseEnterHandler.bind(this)}
           onMouseLeave={this._onMouseLeaveHandler.bind(this)}>
        <div className={controlsClass}
             style={{visibility: this.state.showAdditionalControls || this.state.isDetached ? 'visible' : 'hidden'}}>
          {!this.state.isDetached && <div className="control-btn hover" onClick={this._onClickDetach.bind(this)}>
            <i className="ic ic-detach ic-16px"></i>
          </div>}
          {this.state.isDetached && <div className="control-btn hover" onClick={this._onClickClose.bind(this)}>
            <i className="ic ic-close ic-11px"></i>
          </div>}
        </div>
        <VelocityComponent animation={{marginLeft: this.state.isVisible ? 0 : '-456px'}} duration={500}>
          {this._renderPlayer()}
        </VelocityComponent>
      </div>
    );
  }
}

Player.propTypes = {
  player: PropTypes.object.isRequired
};

const mapStateToProps = function ({common: {player}}, ownProps) {

  return {player};
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({SetPlayer}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Player);



// WEBPACK FOOTER //
// ./src/containers/Player/index.js